/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhysicianSubscriberCount
 */
export interface PhysicianSubscriberCount {
    /**
     * 
     * @type {string}
     * @memberof PhysicianSubscriberCount
     */
    physician_id?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicianSubscriberCount
     */
    count?: number;
}

/**
 * Check if a given object implements the PhysicianSubscriberCount interface.
 */
export function instanceOfPhysicianSubscriberCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PhysicianSubscriberCountFromJSON(json: any): PhysicianSubscriberCount {
    return PhysicianSubscriberCountFromJSONTyped(json, false);
}

export function PhysicianSubscriberCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhysicianSubscriberCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'physician_id': !exists(json, 'physician_id') ? undefined : json['physician_id'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function PhysicianSubscriberCountToJSON(value?: PhysicianSubscriberCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'physician_id': value.physician_id,
        'count': value.count,
    };
}

